export default __webpack_public_path__ + "static/media/default-player.cf3247e8.png";